import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure, useToast
} from "@chakra-ui/react";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";

import { postCandidates } from "../../shared/Api";
import { errorToast, successToast } from "../../shared/helper/ToastHelper";
import { adminKeys } from "../../shared/QueryKeys";
import { saveByteArray } from "../../shared/Utils";

type CreateCandidateProps = {
  onCandidateCreated: (file: File) => void;
};

const CreateCandidate = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [file, setFile] = useState<File | null>(null);

  function handleChange(e: any) {
    setFile(e.target.files[0]);
  }

  const createCandidateMutation = useMutation(postCandidates,
    {
      onSuccess: (TData) => {
        successToast(toast, "Candidatos creados");
        saveByteArray("Candidates created", TData.data);
        return queryClient.invalidateQueries(adminKeys.candidates());
      },
      onError: (error) => {
        errorToast(toast, "Error creando candidatos");
      },
    } );
  function handleClick() {
    if (file) {
      createCandidateMutation.mutate(file);
    }
    onClose();
  }

  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme="teal" onClick={onOpen}>
        Crear Candidatos
      </Button>
      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Nuevos candidatos</ModalHeader>
          <ModalBody>
            <FormControl id="file-form-control" paddingBottom="6">
              <FormLabel>Candidatos</FormLabel>
              <input name="file-input" type="file" onChange={handleChange} />
              <FormHelperText>
                Seleccione un archivo en formato xlsx.
              </FormHelperText>
            </FormControl>
          </ModalBody>
          <ModalCloseButton />
          <ModalFooter>
            <Button
                colorScheme="teal"
                type="submit"
                isDisabled={!file}
                onClick={handleClick}
            >
              Crear
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CreateCandidate;